/* TC cart drawer scroll fix (Oct 2026): long Easify personalization lists pushed the
   quantity / remove controls under the footer. Make the item list scroll on its own.
   Injected from JS because custom.css has an unclosed @media block that would swallow it. */
(function () {
  var css =
    'cart-drawer .drawer__inner{display:flex !important;flex-direction:column !important;height:100% !important;max-height:100vh !important;max-height:100dvh !important;overflow:hidden !important;}' +
    'cart-drawer .drawer__header{flex-shrink:0 !important;}' +
    'cart-drawer cart-drawer-items{flex:1 1 auto !important;min-height:0 !important;overflow-y:auto !important;-webkit-overflow-scrolling:touch;}' +
    'cart-drawer .drawer__footer{flex-shrink:0 !important;}';
  var s = document.createElement('style');
  s.id = 'tc-cart-drawer-scroll-fix';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

/* TC Easify popup: don't close when the customer clicks outside it (Oct 2026).
   Easify closes the popup on any click on its full-screen backdrop (.tpo_modal-background),
   which wiped everything the customer had typed. Swallow those clicks; the X still works. */
(function () {
  ['pointerdown', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchend'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var el = e.target;
      if (el && el.classList && el.classList.contains('tpo_modal-background')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  });
})();

/* TC parent fields visibility (Oct 2026): the 4 "Partner X - Parent Y" Easify fields should
   hide on Fill-in-the-Blank like the old "Parents Hebrew Names" field. Partner 1 - Parent 1 kept
   the old field's UUID (already mapped in global.js); tag the 3 new ones the same way.
   If these fields are ever deleted and recreated in Easify, update these UUIDs. */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;
  var ids = [
    'a475b0ad-8b55-4830-8ed7-cc3432463b52', // Partner 1 - Parent 2
    '58b73381-7847-489f-9baf-8623f5eeadab', // Partner 2 - Parent 1
    'b9f6e30a-bf5b-4811-91e3-fbc965cb0f4e'  // Partner 2 - Parent 2
  ];
  function tag() {
    ids.forEach(function (u) {
      document.querySelectorAll('.tpo_option-container[class*="' + u + '"]').forEach(function (el) {
        if (!el.classList.contains('tpo-pers-cust-field')) el.classList.add('tpo-pers-cust-field');
      });
    });
  }
  new MutationObserver(tag).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  tag();
})();

/* TC cart fix v7 (Oct 2026)
   - Keeps the cart drawer in sync after Easify (or any) add-to-cart
     (watches real network traffic, queues refreshes, re-checks after drawer opens)
   - "I'll do it after my order" / Easify-closed fallback: the intercept popup re-submits the
     product form. requestSubmit() fails (ATC button isn't type=submit) so it falls back to a
     native form.submit(), which skips all JS and loads /cart. We intercept both the submit
     event AND native form.submit() and add via AJAX, so the drawer opens instead.
   Placed FIRST so legacy code errors below can't block it. */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  var busy = false, pending = false, pendingOpen = false;

  function inject(data, openAfter) {
    var drawer = document.querySelector('cart-drawer');
    if (data['cart-drawer']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = data['cart-drawer'];
      var fresh = tmp.querySelector('#CartDrawer');
      var live = document.getElementById('CartDrawer');
      if (fresh && live) {
        live.innerHTML = fresh.innerHTML;
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov && drawer && typeof drawer.close === 'function') {
          ov.addEventListener('click', function () { drawer.close(); });
        }
      }
    }
    if (data['cart-icon-bubble']) {
      var tmp2 = document.createElement('div');
      tmp2.innerHTML = data['cart-icon-bubble'];
      var freshB = tmp2.querySelector('#cart-icon-bubble');
      var liveB = document.getElementById('cart-icon-bubble');
      if (freshB && liveB) liveB.innerHTML = freshB.innerHTML;
    }
    if (drawer) {
      var hasItems = !!document.querySelector('#CartDrawer .cart-item');
      if (hasItems) drawer.classList.remove('is-empty');
      if (openAfter && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
    }
  }

  function refresh(openAfter) {
    if (busy) { pending = true; pendingOpen = pendingOpen || !!openAfter; return; }
    busy = true;
    fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) { inject(data, openAfter); })
      .catch(function (e) { console.log('TC cart refresh error', e); })
      .finally(function () {
        busy = false;
        if (pending) { var o = pendingOpen; pending = false; pendingOpen = false; refresh(o); }
      });
  }

  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (e.name && e.name.indexOf('/cart/add') !== -1) refresh(true);
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) { console.log('TC: PerformanceObserver unavailable', e); }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        refresh(false);
        setTimeout(function () { refresh(false); }, 900);
        setTimeout(function () { refresh(false); }, 2200);
      }
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  function addMinimal(form) {
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + form.id + '"]');
    var id = idEl ? parseInt(idEl.value, 10) : null;
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    if (!id) return Promise.reject(new Error('no variant id'));
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { if (!r.ok) throw new Error('minimal add failed ' + r.status); });
  }

  function ajaxAdd(form) {
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('form add failed ' + r.status);
        refresh(true);
      })
      .catch(function (err) {
        console.log('TC form add failed, retrying minimal add', err);
        return addMinimal(form).then(function () { refresh(true); });
      })
      .catch(function (err2) {
        console.log('TC direct add failed, falling back to cart page', err2);
        window.location.href = '/cart';
      });
  }

  function isProductForm(form) {
    return form && form.querySelector && form.querySelector('[name="id"]') &&
      String(form.getAttribute('action') || form.action || '').indexOf('/cart/add') !== -1;
  }

  document.addEventListener('submit', function (e) {
    if (!window._tcBypassed) return;
    var form = e.target;
    if (!isProductForm(form)) return;
    window._tcBypassed = false;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form);
  }, true);

  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (window._tcBypassed && isProductForm(this)) {
      window._tcBypassed = false;
      ajaxAdd(this);
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  window._tcCartFix = 'v8';
})();

/* TC Blooms + Pomegranate (Oct 2026): these ketubahs were missing from the hardcoded
   product lists in theme.liquid, so they didn't default to Personalized or show the
   artist byline. Handle them here. */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;
  var extraKetubahs = {
    '10630522568985': 'Jess Phoenix',   // Blooms
    '10791406436633': 'Arielle Stein'   // Pomegranate
  };
  function init() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var pid = meta ? String(meta.id) : '';
    if (!extraKetubahs[pid]) return;

    var radio = document.querySelector('input[name="Personalization Options"][value="Personalized"]');
    if (radio) {
      if (!radio.checked) radio.click();
    } else {
      var btns = Array.from(document.querySelectorAll('.product-variant-options button, label'));
      var pb = btns.find(function (b) { return b.textContent.trim() === 'Personalized'; });
      if (pb && !pb.classList.contains('active') && !pb.checked) pb.click();
    }

    var h1 = document.querySelector('h1');
    if (h1 && !document.getElementById('tc-artist-byline')) {
      var byline = document.createElement('div');
      byline.id = 'tc-artist-byline';
      byline.className = 'tc-artist-byline';
      byline.textContent = 'by ' + extraKetubahs[pid];
      h1.insertAdjacentElement('afterend', byline);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 200); });
  } else {
    setTimeout(init, 200);
  }
})();

/* Legacy theme code - wrapped so an error here can't break anything else */
try {
  $(".product-color-swatch").on("click", function() {

    let wrapper = $(event.target)[0].closest(".card-wrapper")
    image = $(wrapper).find("img")[0]
    link = $(wrapper).find(".card__heading.h5 .full-unstyled-link")[0]

    let variantImage = this.dataset.variantImage
    let variantLink = this.dataset.variantLink

    if (!variantImage.includes("no-image")) {
      image.src = variantImage
      image.srcset = variantImage
    }

    if (variantLink != "" ) {
      link.href = variantLink
    }

    event.preventDefault()
  })
} catch (e) { console.log('TC legacy swatch code skipped', e); }

try {
  let menuOpen = false
  $("#Details-menu-drawer-container").on("click", function() {
    if(window.location.pathname == "/") {
      if(!menuOpen) {
        $("header.header")[0].style.cssText = 'background:#292656 !important';
        menuOpen = true
      } else {
        $("header.header")[0].style.cssText = 'background:transparent !important';
        menuOpen = false
      }
    }
  })
} catch (e) { console.log('TC legacy menu code skipped', e); }
